import type { SVGProps } from 'react';

const SvgCollection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 6h-4c-.7 0-1.28-.39-1.95-.83C11.23 4.62 10.3 4 9 4H6C4.35 4 3 5.35 3 7v10c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V9c0-1.65-1.35-3-3-3M6 6h3c.7 0 1.28.39 1.95.83C11.77 7.38 12.7 8 14 8h4c.55 0 1 .45 1 1v1H5V7c0-.55.45-1 1-1m12 12H6c-.55 0-1-.45-1-1v-5h14v5c0 .55-.45 1-1 1"
    />
  </svg>
);
export default SvgCollection;
